var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectSwipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project_-_Swipe",
    "data-name": "Project - Swipe",
    transform: "translate(-845 -471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4384",
    "data-name": "Rectangle 4384",
    width: 50,
    height: 50,
    transform: "translate(845 471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-swipe-right-3769497",
    transform: "translate(651.301 383.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34250",
    "data-name": "Path 34250",
    d: "M248.111,186.033a3.1,3.1,0,0,0-1.721-.331l.066-.133a2.7,2.7,0,0,0,.2-2.25,3.222,3.222,0,0,0-1.456-1.787,3.1,3.1,0,0,0-1.721-.331l.066-.132a2.981,2.981,0,0,0-1.258-4.037,3.1,3.1,0,0,0-1.721-.331l2.714-5.1a2.7,2.7,0,0,0,.2-2.25,3.222,3.222,0,0,0-1.456-1.787,2.7,2.7,0,0,0-2.25-.2,3.222,3.222,0,0,0-1.787,1.456l-7.28,13.832c.066-4.964-1.919-5.692-2.383-5.824a2.773,2.773,0,0,0-2.581.6c-3.773,3.375-1.853,18.994-1.655,20.781a.7.7,0,0,0,.662.6h.066a.775.775,0,0,0,.6-.728c-.6-4.633-1.589-17.141,1.191-19.59a1.5,1.5,0,0,1,1.39-.331c1.39.331,1.456,4.765,1.125,7.611a.625.625,0,0,0,.6.728.667.667,0,0,0,.728-.464l.132-.132,8.67-16.413a1.516,1.516,0,0,1,.993-.794,1.68,1.68,0,0,1,1.258.133,1.516,1.516,0,0,1,.794.993,1.68,1.68,0,0,1-.132,1.258l-6.75,12.774a.681.681,0,1,0,1.191.662l.464-.861,2.449-4.7a1.658,1.658,0,1,1,2.912,1.588l-3.111,5.824a.67.67,0,0,0,.265.927.5.5,0,0,0,.331.066.7.7,0,0,0,.6-.331l.331-.6.794-1.522.728-1.39a1.516,1.516,0,0,1,.993-.794,1.68,1.68,0,0,1,1.258.132,1.516,1.516,0,0,1,.794.993,1.68,1.68,0,0,1-.132,1.258l-2.184,4.1a.67.67,0,0,0,.265.927.5.5,0,0,0,.331.066.7.7,0,0,0,.6-.331l.927-1.787a1.638,1.638,0,0,1,2.25-.662,1.516,1.516,0,0,1,.794.993,1.681,1.681,0,0,1-.132,1.258l-1.19,2.119c-1.588,3.045-6.486,11.118-9.927,12.177a.759.759,0,0,0-.464.861.658.658,0,0,0,.662.464h.2c4.7-1.456,10.457-12.376,10.721-12.839l1.258-2.317a3.1,3.1,0,0,0-1.257-4.1Z",
    transform: "translate(-22.684 -68.976)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34251",
    "data-name": "Path 34251",
    d: "M240.45,94.555l-1.059-3.64a.65.65,0,1,0-1.258.331l.529,1.853c-4.633-1.721-24.818-8.537-40.636.4a.732.732,0,0,0-.265.927.669.669,0,0,0,.927.265c15.553-8.8,35.672-1.787,39.709-.265l-2.383.662a.719.719,0,0,0-.464.794.658.658,0,0,0,.662.464h.2l3.64-1.059a.51.51,0,0,0,.4-.728Z",
    transform: "translate(0 0)",
    fill: "#6e6f71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSwipe);
export default __webpack_public_path__ + "static/media/projectSwipe.5804066de68d67f356a8536440dd840d.svg";
export { ForwardRef as ReactComponent };